<template>
    <div class="laptop" > <!-- @click="alert('laptop')" -->
        <div class="sprite">

            <!-- SCREEN -->
            <div class="screen">
                <div class="screen-image" :class="{ active: !showSystem }"></div>
                <div class="screen-overlay"></div>

                <!-- KLEPTOS MINI -->
                <!-- <div class="kleptos-mini">
                    <slot></slot>
                </div> -->

            </div>

            <!-- LIGHTS -->
            <div class="indicator-light-1"></div>
            <div class="indicator-light-2"></div>
            <div class="indicator-light-3"></div>
            <div class="indicator-light-4"></div>

        </div>
    </div>
</template>

<script>
    // import { mapActions } from 'vuex';
    import { mapGetters } from 'vuex';
    // import Header from './Header/Header';

    export default {
        components: {
            // kleptosHeader: Header,
        },
        props: {
            // theme: {
            //     type: String,
            //     required: true
            // },
        },
        computed: {
            ...mapGetters('gameOS', [
                'showSystem',
                // 'getTheme'
            ])
        }
    }
</script>

<style lang="scss" scoped>

    //-----------------------------------------------------------------
    // LAPTOP
    // https://stackoverflow.com/questions/36050537/how-to-match-3d-perspective-of-real-photo-and-object-in-css3-3d-transforms
    // https://codepen.io/liquidvisual/pen/XoVRVr
    //-----------------------------------------------------------------

    .sprite {
        position: relative; // new?
        height: 100%;
        background: url(~@/assets/img/laptop-10@2x.png) no-repeat;
        background-size: 100%;
        // border: 1px dashed red;
        // opacity: 0.99;
    }

    //-----------------------------------------------------------------
    // SCREEN
    //-----------------------------------------------------------------

    .screen,
    .screen-image,
    .screen-overlay {
        position: absolute;
        top: em-calc(15);
        left: em-calc(35);
        width: em-calc(305);
        height: em-calc(200);
        background: black;
        // background: rgba(black, 0.2);
        // background: rgba(yellow, 0.3);
        transform: skew(0deg, -1deg);
        z-index: -1;

        // transform-origin: -6% -6% 0;
        // transform: matrix3d(0.2250257510253056, -0.0028251936825552256, 0, 0.00007034301748712652, 0.012128276958517092, 0.19986062409874183, 0, -0.000013978015343305894, 0, 0, 1, 0, 44.00000000000001, 28.000000000000004, 0, 1) scale(2.5);
        // width: 110%;
        // height: 100%;
    }

    .screen-image,
    .screen-overlay {
        top: 0;
        left: 0;
        // background: url(~@/assets/img/wallpaper-95.jpg) no-repeat;
        // background-size: cover;
    }

    .screen-overlay {
        background: rgba(black, 0.3);
        // background: none;
        z-index: 1; // [LOCKED] - safari
    }

    .screen-image {
        opacity: 0.2;
        // transition: opacity 400ms ease-out;

        &.active {
            // opacity: 1;
            animation: turn-on 1.8s linear 0s alternate 1 forwards;
        }
    }

    @keyframes turn-on {
        0%, 10.999%, 22% {
            opacity: 0.5;
        }
        10%, 21.999%, 43% {
            opacity: 0.7;
        }
        100% {
            opacity: 1;
        }
    }

    // @keyframes turn-on {
    //     from {
    //         opacity: 0.5;
    //     } to {
    //         opacity: 1;
    //     }
    // }

    //-----------------------------------------------------------------
    // KLEPTOS MINI
    //-----------------------------------------------------------------

    .kleptos-mini {
        position: absolute;
        // top: -340px;
        // left: -560px;
        top: -15px;
        left: -26px;
        width: em-calc(1280); //rem-calc(800);
        height: em-calc(768); // rem-calc(480);
        // transform-origin: -6% -6% 0;
        // transform-origin: -1% -1% 0;
        transform-origin: top left;

        // transform: matrix3d(0.2250257510253056, -0.0028251936825552256, 0, 0.00007034301748712652, 0.012128276958517092, 0.19986062409874183, 0, -0.000013978015343305894, 0, 0, 1, 0, 44.00000000000001, 28.000000000000004, 0, 1) scale(2);

        // transform: matrix3d(0.28602839774124156, -0.0028149489090350337, 0, 0.0000891690995697603, 0.014306670636140136, 0.2807455727566073, 0, -0.00002312858533087482, 0, 0, 1, 0, 45, 27, 0, 1);

        transform: matrix3d(0.28053631070590357, -0.003953218089907925, 0, 0.00007216818619486068, 0.015428594398808448, 0.27866279795039217, 0, -0.000026289279553068142, 0, 0, 1, 0, 44, 28, 0, 1) scale(0.87);

        overflow: hidden;

        // transform: scale(0.3);
        // transform-origin: top left;
        // transform: matrix3d(0.053353441764088495, -0.000303164686747639, 0, 0.000016931115580104292, 0.002641083961528464, 0.04681129651476675, 0, -0.000003944132290896003, 0, 0, 1, 0, 79.00000000000001, 47.00000000000001, 0, 1) scale(5.1);

        // transform: matrix3d(0.343133, 0.01547, 0, 0.000079,
        //                    0.001357, 0.344701, 0, -0.000017,
        //                    0, 0, 1, 0,
        //                    142.285595, 152.039415, 0, 1);
        // transform-origin: -41px -37px 0px;

        // transform: perspective(600px) rotateX(-1deg) rotateY(20deg) scale(0.23);
        // overflow: hidden;
        // opacity: 0.5;
        // display: none;
        // z-index: -2;

        filter: blur(2px); // score

        // transform-style: flat !important; // [LOCKED] - fixes blurry image on Chrome (non-retina mostly)
        // will-change: transform;
        // backface-visibility: hidden;
    }

    //-----------------------------------------------------------------
    // INDICATOR LIGHTS
    //-----------------------------------------------------------------

    .indicator-light-1,
    .indicator-light-2,
    .indicator-light-3,
    .indicator-light-4 {
        position: absolute;
        top: em-calc(10);
        width: em-calc(5);
        height: em-calc(6);

        z-index: -1;

        animation: blink 0.6s ease alternate infinite;
    }

    .indicator-light-1 {
        right: em-calc(172);
        background: lighten(#09a222, 10%);

        animation: flicker 3s linear infinite;
        // animation-delay: 10s;
    }

    .indicator-light-2 {
        right: em-calc(165);
        // background: #fff988;
        animation-delay: 1s;
    }

    .indicator-light-3 {
        right: em-calc(158);
        background: lighten(#d02d2b, 2%);
        animation-delay: 3s;
    }

    .indicator-light-4 {
        right: em-calc(151);
        // background: lighten(#18a05d, 2%);
    }

    @keyframes flicker {
        0%, 19.999%, 22%, 62.999%, 64%, 64.999%, 70%, 100% {
            opacity: .99;
        }
        20%, 21.999%, 63%, 63.999%, 65%, 69.999% {
            opacity: 0.4;
        }
    }

    @keyframes blink {
        from {
            opacity: 0;
        } to {
            opacity: 0.95;
        }
    }

</style>